enum ExpenseType {
  OOP = "OOP",
  CARD = "CARD",
  DIRECT_PAY = "DIRECTPAY"
}

export { ExpenseType }
